import { AdvancedAuthenticationType } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllAdvancedAuthenticationTypes = () =>
  getAllEnumOptions(AdvancedAuthenticationType)

export const getAdvancedAuthenticationTypeLabel = (
  key?: AdvancedAuthenticationType,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return AdvancedAuthenticationType[key]
}
